import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  IconButton
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import MapCatalogTable from './MapCatalogTable';
import MapItemDetails from './MapItemDetails';
import RequestSkuModal from './RequestSKUModal';
import useStyles from './styles';


const ChangeMappingModal = ({chargeName, open, setOpen, onConfirm}) => {
  const classes = useStyles();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isRequestSkuOpen, setIsRequestSkuOpen] = useState(false);
  const { isChargeCodesMappedLoading } = useSelector((state: IReduxState) => state.rpa);
  const { saveDataMappingRequestSKUEmailDataLoading } = useSelector((state: IReduxState) => state.email);

  useEffect(() => setSelectedItem(null), [open]);

  const handleRequestSkuOpen = () => {
    setIsRequestSkuOpen(true);
  };

  const handleRequestSkuClose = () => {
    setIsRequestSkuOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="confirm-dialog"
        PaperProps={{
          className: classes.dialogRoot
        }}
        fullWidth
        maxWidth={'lg'}
      >
        <DialogTitle id="confirm-dialog" className={classes.dialogTitleContainer}>
          <div className="flex justify-between items-center py-2">
            <div className="pr-10 pl-4">
              <span>{'Map for: '}</span>
              <span className="font-normal">{chargeName}</span>
            </div>
            <IconButton
              className="border-radius-4 p-2 bg-white border-1-muted"
              onClick={() => setOpen(false)}
            >
              <Icon fontSize="small">close</Icon>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="px-8 pb-5 relative">
          <Grid container className="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              className="uppercase bold"
              title="Click here to add SKU request"
              onClick={handleRequestSkuOpen}
            >
              Request A SKU
            </Button>
          </Grid>
          {selectedItem ?
            <MapItemDetails item={selectedItem} setSelectedItem={setSelectedItem} />
            :
            <MapCatalogTable
              setSelectedItem={setSelectedItem}
            />
          }
          <BackdropCircular loading={isChargeCodesMappedLoading || saveDataMappingRequestSKUEmailDataLoading} />
        </DialogContent>
        <DialogActions className={`justify-between py-6 ${classes.dialogActionContainer}`}>
          {selectedItem ?
            <>
              <Button
                variant="outlined"
                onClick={() => setSelectedItem(null)}
                size="small"
                className="uppercase ml-5"
              >
                Back
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => onConfirm({chargeName, chargeProductData: selectedItem})}
                size="small"
                className="uppercase mr-5"
              >
                Map
              </Button>
            </>
            :
            <Button
              variant="outlined"
              onClick={() => setOpen(false)}
              size="small"
              className="uppercase ml-5"
            >
              Cancel
            </Button>
          }
        </DialogActions>
      </Dialog>
      <RequestSkuModal
        open={isRequestSkuOpen}
        onClose={handleRequestSkuClose}
        selectedItem={selectedItem?.label || chargeName}
      />
    </>
  );
};

export default ChangeMappingModal;
